import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKindergarten1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5369_641)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.8573 6.5049V5.14188H14.5717C14.7991 5.14188 15.0171 5.05156 15.1779 4.89079C15.3387 4.73003 15.429 4.51199 15.429 4.28463V2.57014C15.429 2.34278 15.3387 2.12474 15.1779 1.96397C15.0171 1.80321 14.7991 1.71289 14.5717 1.71289H12C11.7727 1.71289 11.5546 1.80321 11.3938 1.96397C11.2331 2.12474 11.1428 2.34278 11.1428 2.57014V6.5049L6.24788 11.3912C6.16843 11.4713 6.10558 11.5663 6.06291 11.6707C6.02025 11.7752 5.99863 11.887 5.99928 11.9998V22.2868H10.2855V18.0006C10.2855 17.7732 10.3758 17.5552 10.5366 17.3944C10.6974 17.2336 10.9154 17.1433 11.1428 17.1433H12.8573C13.0846 17.1433 13.3027 17.2336 13.4634 17.3944C13.6242 17.5552 13.7145 17.7732 13.7145 18.0006V22.2868H18.0007V11.9998C18.0014 11.887 17.9798 11.7752 17.9371 11.6707C17.8944 11.5663 17.8316 11.4713 17.7521 11.3912L12.8573 6.5049ZM12 13.7143C11.5453 13.7143 11.1092 13.5337 10.7877 13.2122C10.4661 12.8906 10.2855 12.4546 10.2855 11.9998C10.2855 11.5451 10.4661 11.109 10.7877 10.7875C11.1092 10.466 11.5453 10.2854 12 10.2854C12.4547 10.2854 12.8908 10.466 13.2123 10.7875C13.5339 11.109 13.7145 11.5451 13.7145 11.9998C13.7145 12.4546 13.5339 12.8906 13.2123 13.2122C12.8908 13.5337 12.4547 13.7143 12 13.7143Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.7152 22.2869H21.4297C21.6571 22.2869 21.8751 22.1965 22.0359 22.0358C22.1966 21.875 22.2869 21.657 22.2869 21.4296V16.2861H19.7152V22.2869Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.71303 21.4296C1.71303 21.657 1.80334 21.875 1.96411 22.0358C2.12487 22.1965 2.34292 22.2869 2.57027 22.2869H4.28477V16.2861H1.71303V21.4296Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.99938 7.71388C5.88657 7.71323 5.77473 7.73485 5.67028 7.77751C5.56584 7.82017 5.47084 7.88303 5.39074 7.96248L0.24726 13.106C0.128311 13.2265 0.0477329 13.3796 0.0156941 13.5459C-0.0163448 13.7122 0.00159113 13.8842 0.0672386 14.0404C0.131549 14.1969 0.240761 14.3309 0.381109 14.4255C0.521458 14.5201 0.686663 14.571 0.855905 14.5719H4.28489V12.0001C4.28549 11.3183 4.55684 10.6646 5.03927 10.1828L7.50814 7.71388H5.99938Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.753 13.106L18.6096 7.96248C18.5295 7.88303 18.4345 7.82017 18.33 7.77751C18.2256 7.73485 18.1137 7.71323 18.0009 7.71388H16.4922L18.961 10.1828C19.4435 10.6646 19.7148 11.3183 19.7154 12.0001V14.5719H23.1444C23.3136 14.571 23.4788 14.5201 23.6192 14.4255C23.7595 14.3309 23.8687 14.1969 23.9331 14.0404C23.9987 13.8842 24.0166 13.7122 23.9846 13.5459C23.9526 13.3796 23.872 13.2265 23.753 13.106Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5369_641",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgKindergarten1;
